import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { TYPE_SUCCESS, INTERVAL, TYPE_FAIL } from "assets/constants/Constants";
import ShowToast from 'components/ShowToast';
import { deleteUserCall, createAuditLogCall, getUserList } from "lib/axiosUtils";

Modal.setAppElement('#root')
function DeleteUserComponent(props) {
    const [isModalOpen, setModalOpen] = useState(false);
    const [userReason, setUserReason] = useState("");
    const [error, setError] = useState({});
    const [resetButtonLoading, setResetButtonLoading] = useState(false);

    useEffect(() => {
        setModalOpen(props.modelOpen);
    }, [props]);

    const closeModal = () => {
        setModalOpen(false);
        props.cancelUserHandle();
    }

    const cancelUserHandle = (event) => {
        setModalOpen(false);
        props.closeModel();
    }

    const changeReasonhandler = (event) => {
        setUserReason(event.target.value)
    }

    const isFormValid = () => {
        let isValid = true;
        let error = {};
        if (!userReason) {
            isValid = false;
            error.userReason = "Please enter reason";
        }
        setError(error)
        return isValid;
    }

    const handleDeleteUser = async (event) => {
        event.preventDefault();
        try {
            if (isFormValid()) {
                setResetButtonLoading(true);
                if (window.confirm("Are you sure you want to delete this user?")) {
                    const userId = props && props.userData ? props.userData.userId : null;
                    const userFirstName = props && props.userData ? props.userData.firstName : null;
                    const userLastName = props && props.userData ? props.userData.lastName : null;
                    const emailId = props && props.userData ? props.userData.emailId : null;
                    const phoneNumber = props && props.userData ? props.userData.phoneNumber : null;
                    const deleteReason = userReason;

                    let deleteResponse = await deleteUserCall({}, {}, userId);
                    if (deleteResponse.statusCode === 200) {
                        const userName = `${userFirstName} ${userLastName}`;
                        const auditParams = {
                            moduleName: "User Module",
                            userID: props.userId,
                            logText: `${userName} has been deleted. Reason: ${deleteReason}`,
                            userData: { userName, emailId, phoneNumber }
                        };

                        console.log("auditParams::", auditParams);
                        await Promise.all([
                            getUserList({}, {}),
                            createAuditLogCall({}, auditParams)
                        ]);
                        ShowToast('User deleted successfully', TYPE_SUCCESS, INTERVAL, null, "");
                        setResetButtonLoading(false);
                        setModalOpen(false);
                        props.cancelUserHandle?.();
                        window.location.reload();
                    }
                    else {
                        ShowToast('Something went wrong. Please delete again after sometime!', TYPE_FAIL, INTERVAL, this.props, "");
                    }
                }
            }
        } catch (error) {
            console.log("Error occurred while reseting the password", error);
            setResetButtonLoading(false);
        }
    }

    return (
        <>
            <Modal isOpen={isModalOpen} onRequestClose={closeModal} className="program-modal" overlayClassName="program-modal-overlay">
                <div className="program-modal-container job-disabled-width partner-modal-div program-modal-div display-flex-column-div padding-20px" role="document">
                    <form action="" className="display-flex-column-div">
                        <h4 className="import-error-heading text-color-black text-align-center">Delete User</h4>
                        {<div className="display-flex-column-div">
                            <label className="form-label">Enter reason for deleting this user:  <span className="text-danger">*</span></label>
                            <div className="input_box reset-password-input-box display-flex-column-div">
                                <input type='text' name="userReason" className="placeholderColor add-user-input add-user-input-height" placeholder=' Please enter reason' onChange={changeReasonhandler}></input>
                            </div>
                            <div className="text-danger error-msg">
                                {error.userReason}
                            </div>
                        </div>}
                        <br />
                    </form>
                    <div className="form-button-div mt-5">
                        {
                            resetButtonLoading === true ? (<>
                                <div className="spinner-loader">
                                </div>
                            </>) : (
                                <button className="brand-button" onClick={handleDeleteUser}>Delete</button>
                            )
                        }
                        <button className="button-secondary ml-3" onClick={cancelUserHandle}>Cancel</button>
                    </div>
                </div>
            </Modal>
        </>
    );
}
export default DeleteUserComponent;